import React from 'react';
import Currency from '../../components/Agreement/Currency';
import TableRow from '../../components/Agreement/TableRow';
import { formatLessonItems } from '../../utils';

const Table = props => {
  const { lessons } = props;
  const { Items, Depositpayment } = lessons;

  return (
    <div className={"table"}>
      <TableRow
        rowClassName={"table-header"}
        columnNum={9}
        data={[
          { value: "编号" },
          { value: "服务" },
          {},
          { value: "次数" },
          { value: "原价" },
          { value: "优惠价" },
          { value: "需付金额" },
        ]}
      />
      <div className={"item-container"}>
        {formatLessonItems(Items).map(({ code, name, items }, i) => (
          <div key={i} className={"item-row"}>
            <TableRow
              rowClassName={"bold"}
              data={[{ value: code }, { value: name }]}
            />
            {items.map(
              ({ name, qty, gross, price, totalPrice }, j) => (
                <TableRow
                  key={j}
                  columnNum={9}
                  data={[
                    {},
                    { value: name },
                    {},
                    { value: qty },
                    {
                      value: gross,
                      CellComponent: Currency,
                      cellProps: { digits: 0 },
                    },
                    {
                      value: totalPrice,
                      CellComponent: Currency,
                      cellProps: { digits: 0 },
                    },
                    {
                      value: totalPrice,
                      CellComponent: Currency,
                      cellProps: { digits: 0 },
                    },
                  ]}
                />
              )
            )}
          </div>
        ))}
        {Depositpayment > 0 && (
          <TableRow
            rowClassName={"bold"}
            columnNum={9}
            data={[
              {},
              { value: "积分扣减" },
              {},
              { value: 1 },
              {
                value: -1 * Depositpayment,
                CellComponent: Currency,
                cellProps: { digits: 0 },
              },
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default Table;